import type { Vec3 } from "geom/vec3";
import { FIRST_DYNAMIC_REFRACTION_PROBE_LAYER, MAX_DYNAMIC_REFRACTION_PROBE_LAYER } from "../../layerConstants";
import type { RefractionProbePosition } from "./RefractionProbePosition";

function allDynamicRefractionProbeLayers(): number[] {
  const layers: number[] = [];
  for (let layer = FIRST_DYNAMIC_REFRACTION_PROBE_LAYER; layer < MAX_DYNAMIC_REFRACTION_PROBE_LAYER; layer++) {
    layers.push(layer);
  }
  return layers;
}

export class RefractionProbePositionAllocation {
  private freeLayerIndices: number[] = [];

  private probePositions: RefractionProbePosition[] = [];

  constructor() {
    this.freeLayerIndices = allDynamicRefractionProbeLayers();
  }

  tryCreateProbePosition(position: Vec3, referencingId: string | undefined): RefractionProbePosition | undefined {
    const layerIndex = this.freeLayerIndices.shift();
    if (layerIndex === undefined) {
      return undefined;
    }
    const probePosition: RefractionProbePosition = {
      position,
      layerIndex,
      referencingIds: new Set(referencingId !== undefined ? [referencingId] : []),
    };
    this.probePositions.push(probePosition);
    return probePosition;
  }

  removeProbePosition(probePosition: RefractionProbePosition) {
    this.probePositions.splice(this.probePositions.indexOf(probePosition), 1);
    this.freeLayerIndices.push(probePosition.layerIndex);
  }

  getProbePositions(): Readonly<RefractionProbePosition[]> {
    return this.probePositions;
  }

  replaceProbePositionsList(probePositions: RefractionProbePosition[]) {
    this.probePositions = probePositions;
    this.freeLayerIndices = [];
    for (let layer = FIRST_DYNAMIC_REFRACTION_PROBE_LAYER; layer < MAX_DYNAMIC_REFRACTION_PROBE_LAYER; layer++) {
      if (!this.probePositions.some((probe) => probe.layerIndex === layer)) {
        this.freeLayerIndices.push(layer);
      }
    }
  }
}
